import * as Types from '../../../../../graphql.generated';

export type SocialSignInGoogleOneTapMutationVariables = Types.Exact<{
    accessToken: Types.Scalars['String'];
}>;

export type SocialSignInGoogleOneTapMutation = { __typename?: 'Mutation' } & {
    socialSignInGoogleOneTap?: Types.Maybe<
        { __typename?: 'SocialSignInGoogleOneTapResponse' } & Pick<
            Types.SocialSignInGoogleOneTapResponse,
            'success'
        >
    >;
};

export const SocialSignInGoogleOneTapDocument = `
    mutation socialSignInGoogleOneTap($accessToken: String!) {
  socialSignInGoogleOneTap(accessToken: $accessToken) {
    success
  }
}
    `;
export type Requester<C = {}> = <R, V>(
    doc: string,
    vars?: V,
    options?: C
) => Promise<R>;
export function getSdk<C>(requester: Requester<C>) {
    return {
        socialSignInGoogleOneTap(
            variables: SocialSignInGoogleOneTapMutationVariables,
            options?: C
        ): Promise<SocialSignInGoogleOneTapMutation> {
            return requester<
                SocialSignInGoogleOneTapMutation,
                SocialSignInGoogleOneTapMutationVariables
            >(SocialSignInGoogleOneTapDocument, variables, options);
        }
    };
}
export type Sdk = ReturnType<typeof getSdk>;
